import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import RibbonActions from '../components/RibbonActions';
import {
  getProveedores, createProveedor, updateProveedor,
  getOrdenesCompra, getOrdenCompra, createOrdenCompra, updateOrdenCompra, updateEstadoOC, emitirDocSoporte, getDocSoportePDF,
  getOrdenCompraPDF, enviarOrdenCompra,
  getSolicitudesCompra, createSolicitudCompra, updateEstadoSC, convertirSCaOC,
  getProyectos, getCorreoRecepcion,
} from '../services/api';
import FiltroPanel from '../components/FiltroPanel';
import DocHistorialModal, { ClockIcon } from '../components/DocHistorialModal';
import { DEPARTAMENTOS, MUNICIPIOS } from '../data/dianUbicacion';

const HIST_BTN = { background:'#1e293b', border:'1px solid #334155', borderRadius:6, padding:'4px 8px', cursor:'pointer', color:'#93c5fd', display:'inline-flex', alignItems:'center', verticalAlign:'middle' };
const ESTADOS_OC = ['borrador','aprobada','recibida','cancelada'];
const ESTADOS_SC = ['pendiente','aprobada','rechazada','convertida'];
const PRIORIDADES = ['baja','media','alta','urgente'];
const TITULOS = {
  solicitudes:  { h1: 'Solicitudes',       sub: 'Solicitudes de compra' },
  ordenes:      { h1: 'Órdenes de compra', sub: 'Órdenes de compra a proveedores' },
  proveedores:  { h1: 'Proveedores',       sub: 'Directorio de proveedores' },
};

const EC_OC = { borrador:'#94a3b8', aprobada:'#3b82f6', recibida:'#10b981', cancelada:'#ef4444' };
const EC_SC = { pendiente:'#f59e0b', aprobada:'#10b981', rechazada:'#ef4444', convertida:'#8b5cf6' };
const EP    = { baja:'#64748b', media:'#3b82f6', alta:'#f59e0b', urgente:'#ef4444' };

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');

// Dígito de verificación (DV) del NIT/cédula — algoritmo módulo 11 oficial DIAN.
const calcDV = (n) => {
  const s = String(n || '').replace(/\D/g, '');
  if (!s) return '';
  const pesos = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
  const d = s.split('').reverse();
  let sum = 0;
  for (let i = 0; i < d.length; i++) sum += parseInt(d[i] || '0', 10) * (pesos[i] || 0);
  const r = sum % 11;
  return String(r < 2 ? r : 11 - r);
};

// Botón de acción con icono (una sola línea)
const IconBtn = ({ title, onClick, color = '#94a3b8', disabled, children }) => (
  <button title={title} onClick={onClick} disabled={disabled}
    style={{ background: 'none', border: 'none', cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? '#475569' : color, padding: 2, borderRadius: 5, display: 'inline-flex', lineHeight: 0, opacity: disabled ? 0.5 : 1 }}
    onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = '#33415577'; }}
    onMouseLeave={e => (e.currentTarget.style.background = 'none')}>
    {children}
  </button>
);
const IC_EDIT = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IC_DS = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/><line x1="9" y1="11" x2="12" y2="11"/></svg>;
const IC_PDF = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15h6M9 18h4"/></svg>;
const IC_MAIL = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg>;

const INIT_OC  = { proveedor_id:'', proyecto_id:'', fecha_entrega_esperada:'', notas:'', iva_pct:19, items:[{ descripcion:'', cantidad:1, unidad:'und', precio_unitario:0 }] };
const IVA_OPTS = [0, 5, 19];
const INIT_SC  = { proyecto_id:'', prioridad:'media', notas:'', items:[{ descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] };
const INIT_PRV = { razon_social:'', nit:'', email:'', telefono:'', ciudad:'', categoria:'', no_obligado:false, tipo_documento:'31', direccion:'', departamento:'', codigo_departamento:'', codigo_municipio:'', codigo_postal:'', responsabilidad_fiscal:'O-49' };
const RESP_FISCAL = [['O-49','No responsable de IVA'],['O-48','Responsable de IVA'],['O-47','Régimen simple de tributación'],['R-99-PN','No aplica / otro']];
const TIPOS_DOC = [['31','NIT'],['13','Cédula de ciudadanía'],['22','Cédula de extranjería'],['41','Pasaporte'],['12','Tarjeta de identidad'],['50','NIT de otro país']];

export default function Compras() {
  const [sp] = useSearchParams();
  const tab = ['solicitudes', 'ordenes', 'proveedores'].includes(sp.get('tab')) ? sp.get('tab') : 'solicitudes';
  const [ordenes,     setOrdenes]     = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [proyectos,   setProyectos]   = useState([]);
  const [filtroOC,    setFiltroOC]    = useState('');
  const [filtroSC,    setFiltroSC]    = useState('');
  const [modal,       setModal]       = useState(null); // 'oc'|'sc'|'proveedor'|{tipo:'convertir',sc}
  const [verHist,     setVerHist]     = useState(null);
  const [saving,      setSaving]      = useState(false);
  const [formOC,      setFormOC]      = useState(INIT_OC);
  const [editandoOC,  setEditandoOC]  = useState(null); // id de OC en edición, null = nueva
  const [formSC,      setFormSC]      = useState(INIT_SC);
  const [formProv,    setFormProv]    = useState(INIT_PRV);
  const [correoRecProv, setCorreoRecProv] = useState(null);
  const buscarCorreoRecProv = async () => {
    const nit = (formProv.nit || '').replace(/\D/g, '');
    if (nit.length < 6) { setCorreoRecProv(null); return; }
    try {
      const { data } = await getCorreoRecepcion(nit);
      if (data.encontrado && data.email) {
        setCorreoRecProv(data.email);
        setFormProv(f => (f.email ? f : { ...f, email: data.email }));
      } else { setCorreoRecProv(null); }
    } catch { setCorreoRecProv(null); }
  };
  const [convertForm, setConvertForm] = useState({ proveedor_id:'', fecha_entrega_esperada:'' });

  const loadOrdenes     = () => getOrdenesCompra(filtroOC ? { estado: filtroOC } : {}).then(r => setOrdenes(r.data));
  const loadSolicitudes = () => getSolicitudesCompra(filtroSC ? { estado: filtroSC } : {}).then(r => setSolicitudes(r.data));
  const loadProveedores = () => getProveedores().then(r => setProveedores(r.data));

  useEffect(() => {
    loadOrdenes(); loadSolicitudes(); loadProveedores();
    getProyectos().then(r => setProyectos(r.data));
  }, []);
  useEffect(() => { loadOrdenes(); }, [filtroOC]);
  useEffect(() => { loadSolicitudes(); }, [filtroSC]);

  // OC helpers
  const addItemOC    = () => setFormOC(f => ({ ...f, items:[...f.items, { descripcion:'', cantidad:1, unidad:'und', precio_unitario:0 }] }));
  const removeItemOC = i  => setFormOC(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updateItemOC = (i,k,v) => setFormOC(f => ({ ...f, items: f.items.map((it,idx) => idx === i ? {...it,[k]:v} : it) }));
  const subtotalOC = formOC.items.reduce((s,i) => s + Number(i.cantidad)*Number(i.precio_unitario), 0);

  // SC helpers
  const addItemSC    = () => setFormSC(f => ({ ...f, items:[...f.items, { descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] }));
  const removeItemSC = i  => setFormSC(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updateItemSC = (i,k,v) => setFormSC(f => ({ ...f, items: f.items.map((it,idx) => idx === i ? {...it,[k]:v} : it) }));

  const abrirNuevaOC = () => { setEditandoOC(null); setFormOC(INIT_OC); setModal('oc'); };
  const abrirEditarOC = async (oc) => {
    try {
      const { data } = await getOrdenCompra(oc.id);
      setFormOC({
        proveedor_id: data.proveedor_id || '',
        proyecto_id: data.proyecto_id || '',
        fecha_entrega_esperada: data.fecha_entrega_esperada ? String(data.fecha_entrega_esperada).slice(0, 10) : '',
        notas: data.notas || '',
        iva_pct: data.iva_pct != null ? Number(data.iva_pct) : 19,
        items: (data.items || []).map(it => ({ descripcion: it.descripcion, cantidad: Number(it.cantidad), unidad: it.unidad || 'und', precio_unitario: Number(it.precio_unitario) })),
      });
      setEditandoOC(oc.id); setModal('oc');
    } catch (e) { alert(e.response?.data?.error || 'No se pudo cargar la OC'); }
  };

  const handleCreateOC = async () => {
    if (!formOC.proveedor_id) return alert('Seleccione un proveedor');
    setSaving(true);
    try {
      if (editandoOC) await updateOrdenCompra(editandoOC, formOC);
      else await createOrdenCompra(formOC);
      setModal(null); setFormOC(INIT_OC); setEditandoOC(null); loadOrdenes();
    }
    catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const handleCreateSC = async () => {
    if (!formSC.items.some(i => i.descripcion.trim())) return alert('Agregue al menos un ítem con descripción');
    setSaving(true);
    try { await createSolicitudCompra(formSC); setModal(null); setFormSC(INIT_SC); loadSolicitudes(); }
    catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const [emitiendoDS, setEmitiendoDS] = useState(null);
  const generarDS = async (oc) => {
    if (!window.confirm(`Generar Documento Soporte para la compra ${oc.numero} (${oc.proveedor_nombre})?\nSe emite a la DIAN en producción.`)) return;
    setEmitiendoDS(oc.id);
    try {
      const { data } = await emitirDocSoporte(oc.id);
      alert(`✅ Documento Soporte ${data.numero} ACEPTADO por la DIAN.\nCUDS: ${data.cuds.slice(0, 24)}…`);
      loadOrdenes();
    } catch (e) {
      alert('❌ ' + (e.response?.data?.error || 'Error al emitir el Documento Soporte'));
    } finally { setEmitiendoDS(null); }
  };
  const verDsPdf = async (oc) => {
    try {
      const { data } = await getDocSoportePDF(oc.id);
      const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { alert('❌ No se pudo abrir el PDF del documento soporte'); }
  };
  const verOCPdf = async (oc) => {
    try {
      const { data } = await getOrdenCompraPDF(oc.id);
      const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { alert('❌ No se pudo abrir el PDF de la orden de compra'); }
  };
  const [emailOC, setEmailOC] = useState(null); // { oc, para, mensaje }
  const [enviandoOC, setEnviandoOC] = useState(false);
  const enviarOC = async () => {
    const dests = [];
    if (emailOC.usarReg && emailOC.oc.proveedor_email) dests.push(emailOC.oc.proveedor_email);
    if (emailOC.otro?.trim()) dests.push(emailOC.otro.trim());
    if (!dests.length) { alert('❌ Selecciona el correo registrado o escribe uno'); return; }
    setEnviandoOC(true);
    try {
      const fd = new FormData();
      fd.append('para', dests.join(','));
      fd.append('mensaje', emailOC.mensaje || '');
      if (emailOC.adjunto) fd.append('adjunto', emailOC.adjunto);
      const { data } = await enviarOrdenCompra(emailOC.oc.id, fd);
      alert('✅ ' + (data.mensaje || 'Orden enviada'));
      setEmailOC(null);
    } catch (e) { alert('❌ ' + (e.response?.data?.error || 'No se pudo enviar')); }
    finally { setEnviandoOC(false); }
  };

  const handleCreateProv = async () => {
    if (!formProv.razon_social || !formProv.nit) return alert('Razón social y NIT son requeridos');
    setSaving(true);
    try {
      if (formProv.id) await updateProveedor(formProv.id, formProv);
      else await createProveedor(formProv);
      setModal(null); setFormProv(INIT_PRV); loadProveedores();
    }
    catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const handleConvertirSC = async () => {
    if (!convertForm.proveedor_id) return alert('Seleccione un proveedor');
    setSaving(true);
    try {
      await convertirSCaOC(modal.sc.id, convertForm);
      setModal(null); loadSolicitudes(); loadOrdenes();
      alert('✅ OC creada correctamente');
    }
    catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>{TITULOS[tab].h1}</h1><p style={s.sub}>{TITULOS[tab].sub}</p></div>
        <RibbonActions><div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {tab === 'solicitudes' && (
            <FiltroPanel
              fields={[{ tipo: 'select', label: 'Estado', value: filtroSC, onChange: setFiltroSC, capitalize: true, options: [{ value: '', label: 'Todas' }, ...ESTADOS_SC.map(e => ({ value: e, label: e }))] }]}
              onClear={() => setFiltroSC('')}
            />
          )}
          {tab === 'ordenes' && (
            <FiltroPanel
              fields={[{ tipo: 'select', label: 'Estado', value: filtroOC, onChange: setFiltroOC, capitalize: true, options: [{ value: '', label: 'Todas' }, ...ESTADOS_OC.map(e => ({ value: e, label: e }))] }]}
              onClear={() => setFiltroOC('')}
            />
          )}
          <button style={s.btnSecondary} onClick={() => { setFormProv(INIT_PRV); setCorreoRecProv(null); setModal('proveedor'); }}>+ Proveedor</button>
          <button style={s.btnSecondary} onClick={abrirNuevaOC}>+ Orden de compra</button>
          <button style={s.btnPrimary}   onClick={() => setModal('sc')}>+ Solicitud</button>
        </div></RibbonActions>
      </div>

      {/* ── Tab Solicitudes ── */}
      {tab === 'solicitudes' && (
        <>
          <div style={s.card}>
            <table style={s.table}>
              <thead><tr>{['Número','Solicitante','Proyecto','Prioridad','Estado','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {solicitudes.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin solicitudes de compra</td></tr>}
                {solicitudes.map(sc => (
                  <tr key={sc.id}>
                    <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{sc.numero}</td>
                    <td style={s.td}>{sc.solicitante_nombre || '—'}</td>
                    <td style={s.td}>{sc.proyecto_nombre || '—'}</td>
                    <td style={s.td}><span style={{ ...s.badge, background: EP[sc.prioridad]+'22', color: EP[sc.prioridad] }}>{sc.prioridad}</span></td>
                    <td style={s.td}>
                      <select style={s.select} value={sc.estado}
                        onChange={e => updateEstadoSC(sc.id, e.target.value).then(loadSolicitudes)}>
                        {ESTADOS_SC.map(e => <option key={e} value={e}>{e}</option>)}
                      </select>
                    </td>
                    <td style={s.td}>
                      {sc.estado === 'aprobada' && (
                        <button style={s.btnSm} onClick={() => { setConvertForm({ proveedor_id:'', fecha_entrega_esperada:'' }); setModal({ tipo:'convertir', sc }); }}>
                          🔄 Convertir a OC
                        </button>
                      )}
                      {sc.estado === 'convertida' && <span style={{ color:'#8b5cf6', fontSize:12 }}>✓ Convertida</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ── Tab Órdenes ── */}
      {tab === 'ordenes' && (
        <>
          <div style={s.card}>
            <table style={s.table}>
              <thead><tr>{['Número','Proveedor','Proyecto','F. Entrega','Subtotal','IVA','Total','Estado','Cambiar estado','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {ordenes.length === 0 && <tr><td colSpan={10} style={s.empty}>Sin órdenes de compra</td></tr>}
                {ordenes.map(oc => (
                  <tr key={oc.id}>
                    <td style={{ ...s.td, color:'#93c5fd', fontWeight:600, whiteSpace:'nowrap' }}>{oc.numero}</td>
                    <td style={s.td}>{oc.proveedor_nombre}</td>
                    <td style={s.td}>{oc.proyecto_nombre || '—'}</td>
                    <td style={s.td}>{oc.fecha_entrega_esperada ? new Date(oc.fecha_entrega_esperada).toLocaleDateString('es-CO') : '—'}</td>
                    <td style={s.td}>{fmt(oc.subtotal)}</td>
                    <td style={s.td}>{fmt(oc.iva)}</td>
                    <td style={{ ...s.td, fontWeight:700 }}>{fmt(oc.total)}</td>
                    <td style={s.td}><span style={{ ...s.badge, background:EC_OC[oc.estado]+'22', color:EC_OC[oc.estado] }}>{oc.estado}</span></td>
                    <td style={s.td}>
                      <select style={s.select} value={oc.estado} onChange={e => updateEstadoOC(oc.id, e.target.value).then(loadOrdenes)}>
                        {ESTADOS_OC.map(e => <option key={e} value={e}>{e}</option>)}
                      </select>
                    </td>
                    <td style={s.td}>
                      <div style={{ display:'flex', gap:1, alignItems:'center', justifyContent:'flex-start', whiteSpace:'nowrap' }}>
                        <IconBtn title="Historial" onClick={() => setVerHist({ docTipo:'compra', docId: oc.id, numero: oc.numero })}><ClockIcon size={16} /></IconBtn>
                        <IconBtn title="Ver PDF de la orden" color="#60a5fa" onClick={() => verOCPdf(oc)}>{IC_PDF}</IconBtn>
                        <IconBtn title="Enviar al proveedor por correo" color="#34d399" onClick={() => setEmailOC({ oc, usarReg: !!oc.proveedor_email, otro: '', mensaje: '', adjunto: null })}>{IC_MAIL}</IconBtn>
                        {oc.estado === 'borrador' && oc.ds_estado !== 'aceptada' &&
                          <IconBtn title="Editar / corregir OC" color="#60a5fa" onClick={() => abrirEditarOC(oc)}>{IC_EDIT}</IconBtn>}
                        {oc.ds_estado === 'aceptada'
                          ? <span title={`Ver documento soporte · CUDS ${oc.ds_cuds || ''}`} onClick={() => verDsPdf(oc)}
                              style={{ display:'inline-flex', alignItems:'center', gap:4, color:'#34d399', fontSize:12, fontWeight:600, cursor:'pointer', textDecoration:'underline', textUnderlineOffset:'2px' }}>{IC_DS}{oc.ds_numero}</span>
                          : oc.proveedor_no_obligado
                            ? (emitiendoDS === oc.id
                                ? <span style={{ color:'#a78bfa', fontSize:11 }}>Emitiendo…</span>
                                : <IconBtn title="Generar documento soporte (DS)" color="#a78bfa" onClick={() => generarDS(oc)}>{IC_DS}</IconBtn>)
                            : <span style={{ color:'#475569', fontSize:11 }} title="Solo para proveedores no obligados a facturar">—</span>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ── Tab Proveedores ── */}
      {tab === 'proveedores' && (
        <div style={s.card}>
          <table style={s.table}>
            <thead><tr>{['Razón Social','NIT','Categoría','Ciudad','Teléfono','Email'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {proveedores.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin proveedores</td></tr>}
              {proveedores.map(p => (
                <tr key={p.id} style={{ cursor:'pointer' }} onClick={() => { setFormProv({ ...INIT_PRV, ...p }); setCorreoRecProv(null); setModal('proveedor'); }} title="Editar proveedor">
                  <td style={{ ...s.td, fontWeight:600 }}>{p.razon_social} {p.no_obligado && <span style={{ fontSize:10, color:'#f59e0b', border:'1px solid #f59e0b55', borderRadius:4, padding:'1px 5px', marginLeft:6 }}>no obligado</span>}</td>
                  <td style={{ ...s.td, color:'#93c5fd' }}>{p.nit}</td>
                  <td style={s.td}>{p.categoria || '—'}</td>
                  <td style={s.td}>{p.ciudad || '—'}</td>
                  <td style={s.td}>{p.telefono || '—'}</td>
                  <td style={s.td}>{p.email || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Modal nueva Solicitud ── */}
      {modal === 'sc' && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:780 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Nueva Solicitud de Compra</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row3}>
                <div style={s.field}><label style={s.label}>Proyecto (opcional)</label>
                  <select style={s.input} value={formSC.proyecto_id} onChange={e => setFormSC({...formSC, proyecto_id:e.target.value})}>
                    <option value="">Sin proyecto</option>
                    {proyectos.map(p => <option key={p.id} value={p.id}>{p.codigo} — {p.nombre}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Prioridad</label>
                  <select style={s.input} value={formSC.prioridad} onChange={e => setFormSC({...formSC, prioridad:e.target.value})}>
                    {PRIORIDADES.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
              </div>
              <div style={s.field}><label style={s.label}>Notas / Justificación</label>
                <textarea style={{ ...s.input, minHeight:50, resize:'vertical' }} value={formSC.notas} onChange={e => setFormSC({...formSC, notas:e.target.value})} />
              </div>
              <div style={s.itemsHeader}><span style={s.label}>Ítems solicitados</span><button style={s.btnSm} onClick={addItemSC}>+ Agregar</button></div>
              {formSC.items.map((it, i) => (
                <div key={i} style={s.itemRow}>
                  <input style={{ ...s.itemCtrl, flex:3 }} placeholder="Descripción del ítem" value={it.descripcion} onChange={e => updateItemSC(i,'descripcion',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:1 }} type="number" placeholder="Cant." value={it.cantidad} onChange={e => updateItemSC(i,'cantidad',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:1 }} placeholder="Und" value={it.unidad} onChange={e => updateItemSC(i,'unidad',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:2 }} type="number" placeholder="Precio estimado" value={it.precio_estimado} onChange={e => updateItemSC(i,'precio_estimado',e.target.value)} />
                  {formSC.items.length > 1 && <button style={s.removeBtn} onClick={() => removeItemSC(i)}>✕</button>}
                </div>
              ))}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreateSC} disabled={saving}>{saving ? 'Guardando...' : 'Crear solicitud'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal nueva OC ── */}
      {modal === 'oc' && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:780 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{editandoOC ? 'Editar Orden de Compra' : 'Nueva Orden de Compra'}</h2><button style={s.closeBtn} onClick={() => { setModal(null); setEditandoOC(null); }}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row3}>
                <div style={s.field}><label style={s.label}>Proveedor *</label>
                  <select style={s.input} value={formOC.proveedor_id} onChange={e => setFormOC({...formOC, proveedor_id:e.target.value})}>
                    <option value="">Seleccionar proveedor</option>
                    {proveedores.map(p => <option key={p.id} value={p.id}>{p.razon_social}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Proyecto (opcional)</label>
                  <select style={s.input} value={formOC.proyecto_id} onChange={e => setFormOC({...formOC, proyecto_id:e.target.value})}>
                    <option value="">Sin proyecto</option>
                    {proyectos.map(p => <option key={p.id} value={p.id}>{p.codigo} — {p.nombre}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Fecha entrega esperada</label>
                  <input style={s.input} type="date" value={formOC.fecha_entrega_esperada} onChange={e => setFormOC({...formOC, fecha_entrega_esperada:e.target.value})} />
                </div>
              </div>
              {formOC.proveedor_id && (() => {
                const pv = proveedores.find(p => p.id === formOC.proveedor_id);
                const NO_RET = { 'O-15': 'Autorretenedor — se autorretiene, no le practicas retención.', 'O-47': 'Régimen simple — excluido de retefuente.', 'O-13': 'Gran contribuyente — normalmente sin retefuente (verifica el concepto).' };
                const nota = NO_RET[pv?.responsabilidad_fiscal];
                return nota
                  ? <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', margin:'2px 0 12px', fontSize:12, color:'#94a3b8' }}>ℹ️ <strong>{pv?.razon_social}</strong>: {nota}</div>
                  : <div style={{ background:'#422006', border:'1px solid #a16207', borderRadius:8, padding:'8px 12px', margin:'2px 0 12px', fontSize:12, color:'#fde68a' }}>💡 A <strong>{pv?.razon_social}</strong> se le debe practicar <strong>retención</strong> al causar/contabilizar su factura (en Recepción, con la config de retenciones). La orden de compra no la incluye.</div>;
              })()}
              <div style={s.field}><label style={s.label}>Notas</label>
                <textarea style={{ ...s.input, minHeight:50, resize:'vertical' }} value={formOC.notas} onChange={e => setFormOC({...formOC, notas:e.target.value})} />
              </div>
              <div style={s.itemsHeader}><span style={s.label}>Ítems</span><button style={s.btnSm} onClick={addItemOC}>+ Agregar</button></div>
              {formOC.items.map((it, i) => (
                <div key={i} style={s.itemRow}>
                  <input style={{ ...s.itemCtrl, flex:3 }} placeholder="Descripción" value={it.descripcion} onChange={e => updateItemOC(i,'descripcion',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:1 }} type="number" placeholder="Cant." value={it.cantidad} onChange={e => updateItemOC(i,'cantidad',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:1 }} placeholder="Und" value={it.unidad} onChange={e => updateItemOC(i,'unidad',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:2 }} type="number" placeholder="Precio unit." value={it.precio_unitario} onChange={e => updateItemOC(i,'precio_unitario',e.target.value)} />
                  <span style={s.itemTotal}>{fmt(Number(it.cantidad)*Number(it.precio_unitario))}</span>
                  {formOC.items.length > 1 && <button style={s.removeBtn} onClick={() => removeItemOC(i)}>✕</button>}
                </div>
              ))}
              <div style={s.totales}>
                <div style={s.totalRow}><span>Subtotal</span><span>{fmt(subtotalOC)}</span></div>
                <div style={s.totalRow}>
                  <span style={{ display:'flex', alignItems:'center', gap:8 }}>
                    IVA
                    <select style={{ ...s.select, height:30, padding:'0 6px' }} value={formOC.iva_pct}
                            onChange={e => setFormOC({ ...formOC, iva_pct:Number(e.target.value) })}>
                      {IVA_OPTS.map(v => <option key={v} value={v}>{v}%</option>)}
                    </select>
                  </span>
                  <span>{fmt(subtotalOC * (Number(formOC.iva_pct) / 100))}</span>
                </div>
                <div style={{ ...s.totalRow, ...s.totalFinal }}><span>Total</span><span>{fmt(subtotalOC * (1 + Number(formOC.iva_pct) / 100))}</span></div>
              </div>
              {formOC.iva_pct === 0 && <p style={{ color:'#94a3b8', fontSize:11, margin:'6px 0 0' }}>Sin IVA — típico para personas naturales no responsables de IVA (documento soporte).</p>}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => { setModal(null); setEditandoOC(null); }}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreateOC} disabled={saving}>{saving ? 'Guardando...' : editandoOC ? 'Guardar cambios' : 'Crear OC'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal convertir SC → OC ── */}
      {modal?.tipo === 'convertir' && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Convertir a Orden de Compra</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginTop:0 }}>Solicitud: <strong style={{ color:'#93c5fd' }}>{modal.sc.numero}</strong></p>
              <div style={s.field}><label style={s.label}>Proveedor *</label>
                <select style={s.input} value={convertForm.proveedor_id} onChange={e => setConvertForm({...convertForm, proveedor_id:e.target.value})}>
                  <option value="">Seleccionar proveedor</option>
                  {proveedores.map(p => <option key={p.id} value={p.id}>{p.razon_social}</option>)}
                </select>
              </div>
              <div style={s.field}><label style={s.label}>Fecha entrega esperada</label>
                <input style={s.input} type="date" value={convertForm.fecha_entrega_esperada} onChange={e => setConvertForm({...convertForm, fecha_entrega_esperada:e.target.value})} />
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleConvertirSC} disabled={saving}>{saving ? 'Creando...' : '🔄 Crear OC'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal nuevo proveedor ── */}
      {modal === 'proveedor' && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{formProv.id ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}>
                  <label style={s.label}>Razón Social / Nombre *</label>
                  <input style={s.input} value={formProv.razon_social} onChange={e => setFormProv({ ...formProv, razon_social:e.target.value })} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Tipo de documento *</label>
                  <select style={s.input} value={formProv.tipo_documento} onChange={e => setFormProv({ ...formProv, tipo_documento:e.target.value })}>
                    {TIPOS_DOC.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>
                </div>
              </div>
              <div style={s.row2}>
                <div style={s.field}>
                  <label style={s.label}>{formProv.tipo_documento === '31' ? 'NIT *' : 'Número de documento *'}</label>
                  <div style={{ display:'flex', gap:6, alignItems:'stretch' }}>
                    <input style={{ ...s.input, flex:1, minWidth:0 }} value={formProv.nit} onChange={e => setFormProv({ ...formProv, nit:e.target.value })} onBlur={buscarCorreoRecProv} placeholder={formProv.tipo_documento === '31' ? '900123456' : 'Cédula sin puntos'} title="Al salir se busca el correo de recepción DIAN por el NIT" />
                    <div title="Dígito de verificación (calculado automáticamente)" style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minWidth:52, padding:'0 8px', background:'#0f172a', border:'1px solid #334155', borderRadius:8 }}>
                      <span style={{ fontSize:9, color:'#64748b', lineHeight:1 }}>DV</span>
                      <span style={{ fontSize:16, fontWeight:700, color:'#93c5fd', lineHeight:1.2 }}>{calcDV(formProv.nit) || '–'}</span>
                    </div>
                  </div>
                </div>
                <div style={s.field}>
                  <label style={s.label}>Dirección</label>
                  <input style={s.input} value={formProv.direccion} onChange={e => setFormProv({ ...formProv, direccion:e.target.value })} />
                </div>
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Email</label>
                  <input style={s.input} value={formProv.email || ''} onChange={e => setFormProv({ ...formProv, email:e.target.value })} />
                  {correoRecProv && (
                    <span style={{ fontSize:11, color: formProv.email === correoRecProv ? '#34d399' : '#93c5fd', marginTop:3, display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' }}>
                      📩 Recepción DIAN: {correoRecProv}
                      {formProv.email !== correoRecProv && <button type="button" onClick={() => setFormProv(f => ({ ...f, email: correoRecProv }))} style={{ background:'none', border:'1px solid #334155', borderRadius:5, color:'#93c5fd', fontSize:10, padding:'1px 6px', cursor:'pointer' }}>usar</button>}
                    </span>
                  )}
                </div>
                <div style={s.field}><label style={s.label}>Teléfono</label>
                  <input style={s.input} value={formProv.telefono || ''} onChange={e => setFormProv({ ...formProv, telefono:e.target.value })} /></div>
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Departamento</label>
                  <select style={s.input} value={formProv.codigo_departamento || ''}
                    onChange={e => { const d = DEPARTAMENTOS.find(x => x.code === e.target.value);
                      setFormProv({ ...formProv, codigo_departamento:e.target.value, departamento:d ? d.name : '', codigo_municipio:'', ciudad:'' }); }}>
                    <option value="">— Seleccionar —</option>
                    {DEPARTAMENTOS.map(d => <option key={d.code} value={d.code}>{d.name}</option>)}
                  </select></div>
                <div style={s.field}><label style={s.label}>Municipio / Ciudad</label>
                  <select style={s.input} value={formProv.codigo_municipio || ''} disabled={!formProv.codigo_departamento}
                    onChange={e => { const m = MUNICIPIOS.find(x => x.code === e.target.value);
                      setFormProv({ ...formProv, codigo_municipio:e.target.value, ciudad:m ? m.name : '' }); }}>
                    <option value="">{formProv.codigo_departamento ? '— Seleccionar —' : 'Elige departamento'}</option>
                    {MUNICIPIOS.filter(m => m.code.slice(0, 2) === formProv.codigo_departamento).map(m => <option key={m.code} value={m.code}>{m.name}</option>)}
                  </select></div>
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Código postal <span style={{ color:'#64748b', fontWeight:400 }}>(casilla 43 del RUT)</span></label>
                  <input style={s.input} value={formProv.codigo_postal || ''} placeholder="Ej: 055410" onChange={e => setFormProv({ ...formProv, codigo_postal:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Responsabilidad fiscal <span style={{ color:'#64748b', fontWeight:400 }}>(casilla 53)</span></label>
                  <select style={s.input} value={formProv.responsabilidad_fiscal || 'O-49'} onChange={e => setFormProv({ ...formProv, responsabilidad_fiscal:e.target.value })}>
                    {RESP_FISCAL.map(([v, l]) => <option key={v} value={v}>{v} — {l}</option>)}
                  </select></div>
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Categoría</label>
                  <input style={s.input} value={formProv.categoria || ''} onChange={e => setFormProv({ ...formProv, categoria:e.target.value })} /></div>
                <div style={s.field} />
              </div>
              <div style={{ marginTop:12, padding:'10px 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8 }}>
                <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', color:'#cbd5e1', fontSize:13 }}>
                  <input type="checkbox" checked={formProv.no_obligado} onChange={e => setFormProv({ ...formProv, no_obligado:e.target.checked })} />
                  Proveedor <b>NO obligado a facturar</b> — habilita emitir Documento Soporte (personas con cédula que solo pasan cuenta de cobro)
                </label>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreateProv} disabled={saving}>{saving ? 'Guardando...' : 'Crear proveedor'}</button>
            </div>
          </div>
        </div>
      )}
      {emailOC && (
        <div style={s.overlay} onClick={() => setEmailOC(null)}>
          <div style={{ ...s.modal, maxWidth: 460 }} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Enviar orden {emailOC.oc.numero}</h2><button style={s.closeBtn} onClick={() => setEmailOC(null)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginTop:0 }}>Proveedor: <b style={{ color:'#e2e8f0' }}>{emailOC.oc.proveedor_nombre}</b>. Se adjunta el PDF de la orden.</p>
              <div style={s.field}><label style={s.label}>Correo registrado del proveedor</label>
                {emailOC.oc.proveedor_email
                  ? <label style={{ display:'flex', alignItems:'center', gap:8, color:'#cbd5e1', fontSize:13 }}>
                      <input type="checkbox" checked={emailOC.usarReg} onChange={e => setEmailOC({ ...emailOC, usarReg: e.target.checked })} />
                      {emailOC.oc.proveedor_email}
                    </label>
                  : <span style={{ color:'#f59e0b', fontSize:12 }}>Este proveedor no tiene correo registrado — escribe uno abajo.</span>}
              </div>
              <div style={s.field}><label style={s.label}>Otro correo (opcional)</label>
                <input style={s.input} value={emailOC.otro} onChange={e => setEmailOC({ ...emailOC, otro: e.target.value })} placeholder="otro@correo.com" /></div>
              <div style={s.field}><label style={s.label}>Mensaje (opcional)</label>
                <textarea style={{ ...s.input, height:'auto', minHeight:80, padding:'8px 11px', resize:'vertical' }} value={emailOC.mensaje} onChange={e => setEmailOC({ ...emailOC, mensaje: e.target.value })} placeholder="Mensaje para el proveedor…" /></div>
              <div style={s.field}><label style={s.label}>Adjuntar documento (opcional)</label>
                <input type="file" onChange={e => setEmailOC({ ...emailOC, adjunto: e.target.files?.[0] || null })}
                  style={{ color:'#cbd5e1', fontSize:12 }} />
                {emailOC.adjunto && <span style={{ color:'#93c5fd', fontSize:11 }}>📎 {emailOC.adjunto.name} ({Math.round(emailOC.adjunto.size/1024)} KB)</span>}
                <span style={{ color:'#64748b', fontSize:11 }}>Se envía junto con el PDF de la orden. Máx. 10 MB.</span></div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setEmailOC(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: enviandoOC ? 0.7 : 1 }} disabled={enviandoOC} onClick={enviarOC}>{enviandoOC ? 'Enviando…' : 'Enviar con PDF'}</button>
            </div>
          </div>
        </div>
      )}
      {verHist && <DocHistorialModal {...verHist} onClose={() => setVerHist(null)} />}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  btnSm:       { background:'#1e40af', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  tabs:        { display:'flex', gap:4, marginBottom:20, borderBottom:'1px solid #334155' },
  tab:         { background:'transparent', border:'none', color:'#64748b', padding:'10px 18px', fontSize:13, cursor:'pointer', borderBottom:'2px solid transparent', marginBottom:-1 },
  tabActive:   { color:'#93c5fd', borderBottomColor:'#3b82f6' },
  filtros:     { display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' },
  chip:        { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'6px 14px', borderRadius:20, fontSize:12, cursor:'pointer' },
  chipActive:  { background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'8px 6px', color:'#64748b', fontSize:10.5, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032', whiteSpace:'nowrap' },
  td:          { padding:'5px 6px', color:'#cbd5e1', fontSize:11.5, borderBottom:'1px solid #1a2332', verticalAlign:'middle' },
  empty:       { padding:'32px', textAlign:'center', color:'#475569' },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  select:      { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'2px 4px', fontSize:11, cursor:'pointer' },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:640, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  row3:        { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  itemsHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 },
  itemRow:     { display:'flex', gap:8, alignItems:'center', marginBottom:8 },
  itemCtrl:    { height:38, padding:'0 10px', width:0, minWidth:0, background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none', cursor:'pointer' },
  itemTotal:   { color:'#10b981', fontSize:13, minWidth:72, flexShrink:0, textAlign:'right', fontWeight:600 },
  removeBtn:   { background:'#450a0a', border:'none', color:'#fca5a5', borderRadius:6, padding:'4px 8px', cursor:'pointer', fontSize:12 },
  totales:     { background:'#0f172a', borderRadius:10, padding:'14px 18px', marginTop:16 },
  totalRow:    { display:'flex', justifyContent:'space-between', color:'#94a3b8', fontSize:13, marginBottom:6 },
  totalFinal:  { color:'#f1f5f9', fontWeight:700, fontSize:15, borderTop:'1px solid #334155', paddingTop:8, marginTop:4 },
};
